<p class="subtitle has-text-weight-bold is-size-3">Forecast METEOGRAM (Ulsan)</p>

<div class="box mb-6 has-text-centered">
    <img [src]="getImageSource()">
</div>
